import React from 'react';

const PriceDisplay = ({ product, currency, className = "" }) => {
  const isOnSale = product.is_on_sale && product.sale_discount_percentage > 0;
  const originalPrice = product[currency];
  const discountedPrice = product[`discounted_${currency}`] || originalPrice;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {isOnSale ? (
        <>
          <span className="text-lg font-semibold text-red-600">
            {discountedPrice} {currency}
          </span>
          <span className="text-sm text-gray-500 line-through">
            {originalPrice} {currency}
          </span>
          <span className="text-xs bg-red-100 text-red-600 px-2 py-1 rounded-full font-medium">
            -{product.sale_discount_percentage}%
          </span>
        </>
      ) : (
        <span className="text-lg font-semibold text-brownSkin">
          {originalPrice} {currency}
        </span>
      )}
    </div>
  );
};

export default PriceDisplay; 